<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div class="title">{{this.$t('kjsy.jl')}}</div>
        </div>
        <ul class="tab-box">
          <li class="tab" :class="{active: currency == 'ETH'}" @click="tab(4,'ETH')">{{this.$t('langNew.zbsy')}}(ETH)</li>
          <li class="tab" :class="{active: currency == 'USDT'}" @click="tab(4,'USDT')">{{this.$t('langNew.zbsy')}}(USDT)</li>
        </ul>
        <div class="cont-box" @scroll="listenScroll">
                <div class="num">{{this.$t('kjsy.zjlsl')}}{{sumMoney | toFixed}} {{currency}}</div>
                <ul class="table-th">
                    <li class="th">{{this.$t('kjsy.sj')}}</li>
                    <li class="th">{{this.$t('kjsy.sl')}}</li>
                    <li class="th">{{this.$t('kjsy.sm')}}</li>
                </ul>
                <div class="list-bg">
                    <ul class="ul-box">
                        <li class="list" v-for="(item,index) in listData" :key="index">
                            <div class="text">{{item.add_time}}</div>
                            <div class="text">{{item.money}} ETH</div>
                            <div class="text">{{item.message}}</div>
                        </li>
                    </ul>
                </div>
            <no-data v-show="hasData"></no-data>
            <img id="goTop" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/top.png" alt="">
        </div>
    </div>

</template>

<script>
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
let that = this;
export default {
    name: 'loanProceeds',
    data () {
        return {
            curIdx: 4,
            currency: 'ETH',
            uid: '',
            token: '',
            listData: [],
            hasData: false,
            isGoTOP: false,
            sumMoney: 0,
            scrollbarObj: {
                fade: true
            },
             // 这个配置用于做下拉刷新功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启下拉刷新，可以配置顶部下拉的距离（threshold） 来决定刷新时机以及回弹停留的距离（stop）
            pullDownRefreshObj: {
                threshold: 90,
                stop: 40,
                txt: this.$t('tips.sxcg')
            },
            // 这个配置用于做上拉加载功能，默认为 false。当设置为 true 或者是一个 Object 的时候，可以开启上拉加载，可以配置离底部距离阈值（threshold）来决定开始加载的时机
            pullUpLoadObj: {
                threshold: 0,
                txt: {
                    more: this.$t('tips.jzgd'),
                    noMore: this.$t('tips.mygdsjl')
                }
            },
            startY: 0, // 纵轴方向初始化位置
            scrollToY: 0,
            scrollToTime: 500,
            page: 1,
            limit: 10,
            curDataLength: 10,
            timestamp: 0
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
        this.token = localStorage.getItem('token');
        this.timestamp = localStorage.getItem('timestamp') || 0;
        this.currency = this.$route.query.currency || 'ETH';
    },
    mounted() {
        this.getMyLog();
    },
    methods: {
        goBack(){
            this.$router.push('/loan');
        },
        getMyLog(){
            let params = {
                tab: this.curIdx,
                currency: this.currency,
                page: this.page
            }
            this.$ajax.post('/web/myLog',params).then((res) => {
                if(res.data.code == 0){
                  let resData = res.data.data;
                  if(resData.length > 0){
                      this.hasData = false
                      this.listData = this.listData.concat(resData);
                      this.curDataLength = resData.length;
                  }else{
                      this.hasData = true;
                      this.curDataLength = resData.length;
                  }
                }else{
                  this.hasData = true;
                }
            }).catch(function(err){
                console.log(err);
            })
        },
        listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if(ele.scrollTop > 200){
                this.isGoTOP = true
            }else{
                this.isGoTOP = false
            }
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                    this.page ++;
                    this.getMyLog();
                }
            }
        },
        goTop(){
          $('.cont-box').animate({scrollTop:'0px'},'slow');
        },
        tab(idx,currency){
            this.curIdx = idx;
            this.currency = currency;
            this.page = 1;
            this.listData  = [];
            this.getMyLog();
        },
        jump(){
            this.$router.push('/pay')
        }
    },
    filters: {
        toFixed: function(val){
            return val.toFixed(4)
        },
        times: function(timess){
            var date = new Date((timess - that.timestamp) * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D;
        }
    },
    components:{
        noData,
        VueBetterScroll
    }
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .32rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        padding: 0 .24rem;
        color: #fff;
        font-size: .52rem;
        line-height: 1.2rem;
        box-sizing: border-box;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .tab-box{
        position: fixed;
        top: 1.2rem;
        width: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: .46em .12rem .28rem;
        box-sizing: border-box;
    }
    .tab-box .tab{
        position: relative;
        color: #fff;
        font-size: .42rem;
        text-align: center;
    }
    .tab-box .tab.active{
        font-size: .45rem;
    }
    .tab-box .tab.active::after{
        position: absolute;
        left: 50%;
        bottom: -.2rem;
        content: '';
        width: 1.1rem;
        height: .06rem;
        margin-left: -.55rem;
        background: #2CAADE;
    }
    .cont-box{
        position: absolute;
        left: .24rem;
        right: .24rem;
        top: 2.4rem;
        bottom: 0;
        width: auto;
        height: auto;
        padding: 0 .18rem;
        color: #cecece;
        font-size: .48rem;
        background: rgba(4, 9 ,37,.2);
        border-radius: .1rem;
        box-sizing: border-box;
        overflow: hidden;
    }
    .num{
        padding: .34rem 0 .48rem;
        color: #2CAADE;
        font-size: .45rem;
        text-align: center;
    }
    .table-th{
        display: flex;
        align-items: center;
        padding-bottom: .32rem;
    }
    .table-th .th{
        width: 33.33%;
        color: #fff;
        font-size: .45rem;
        text-align: center;
    }
    .ul-box .list{
        display: flex;
        align-items: stretch;
        padding: .22rem 0;
    }
    .ul-box .list .text{
        width: 33.33%;
        color: #fff;
        font-size: .36rem;
        word-break: break-word;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/pages/loanProceeds.vue